<template >
  <b-overlay
    :show="show"
    variant="light"
    :opacity="0.75"
    blur="2px"
    centered
    style="min-height: 10rem"
  >
    <div v-if="recordData">
      <b-row>
        <b-col cols="12">
          <div class="mb-3">
            <div
              class="h3 d-flex align-items-center justify-content-between border-bottom"
            >
              <span
                class="border-bottom-primary"
                style="border-bottom-width: 4px; padding-bottom: 4px"
                >{{ $t("lbl_orders_detail") }}</span
              >
              <span>#{{ recordData.order_code }}</span>
            </div>
            <StepLine
              :steps="order_statuses"
              :currentStatus="recordData.status"
              :orderId="recordData.id"
              :historyCanceled="historyCanceled"
              :orgServiceTrans="recordData.org_service_transaction"
              @openModalExport="openModalExport"
              @refresh="changeStatus()"
            />
            <div class="pt-1">
              <ProductItem
                v-for="(product, index) in recordData.order_items"
                :class="
                  index < recordData.order_items.length - 1
                    ? 'mb-1 pb-1 border-bottom'
                    : ''
                "
                :key="product.id"
                :product="product"
                :orderData="recordData"
                :ordersId="recordData.id"
              />
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="8" class="border-right" style="margin-right: -1px">
          <div>
            <div
              class="h3 d-flex align-items-center justify-content-between border-bottom"
            >
              <span
                class="border-bottom-primary"
                style="border-bottom-width: 4px; padding-bottom: 4px"
                >{{ $t("lbl_customer_info") }}</span
              >
            </div>
            <!-- <div class="pt-1">
              <div
                class="border-left-primary font-weight-bolder h5 mb-1"
                style="padding: 4px 0 4px 4px; border-left-width: 4px;"
              >{{ $t('lbl_orderer') }}</div>
              <ReceiverInfo :data="handleGetDataReceiver(1)" />
            </div>-->
            <!-- <div>
            <b-form-checkbox
              v-model="record.isPersonReceiver"
              :disabled="!isEdit"
              class="mb-2 mr-sm-2 mb-sm-0"
            >Use this information as the receiver</b-form-checkbox>
            </div>-->
            <div
              class="pt-1"
              v-if="handleGetDataReceiver(2) && handleGetDataReceiver(2).name"
            >
              <div
                class="border-left-primary font-weight-bolder h5 mb-1"
                style="padding: 4px 0 4px 4px; border-left-width: 4px"
              >
                {{ $t("lbl_receiver") }}
              </div>
              <ReceiverInfo :data="handleGetDataReceiver(2)" />
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="4" xxl="4" class="border-left">
          <!-- <div class="mb-3">
            <div class="h3 d-flex align-items-center justify-content-between border-bottom">
              <span
                class="border-bottom-primary"
                style="border-bottom-width: 4px; padding-bottom: 4px;"
              >Orders Status</span>
            </div>
            <OrdersStatus :data="record" />
          </div>-->
          <div>
            <div
              class="h3 d-flex align-items-center justify-content-between border-bottom"
            >
              <span
                class="border-bottom-primary"
                style="border-bottom-width: 4px; padding-bottom: 4px"
                >{{ $t("Thông tin thanh toán") }}</span
              >
            </div>

            <div class="py-21">
              <PaymentMethods :data="recordData" />
              <div class="flex flex-col">
                <div class="mb-2 flex flex-col gap-2 justify-end">
                  <!-- <span>Trạng thái thanh toán</span> -->
                  <div class="d-flex flex-1 justify-content-end">
                    <div
                      v-click-outside="handleCloseDropDown"
                      class="cs-relative"
                      style="width: 250px"
                    >
                      <div
                        @click="handleToggleDropdown"
                        class="flex align-items-center justify-content-between px-1"
                        :class="{
                          'not-payment cursor-pointer':
                            payment_status.value === 1,
                          payment: payment_status.value === 2,
                          status: true,
                        }"
                      >
                        <div>{{ payment_status.label }}</div>
                        <feather-icon
                          v-if="
                            payment_status.value === 1 &&
                            recordData.status !== 100
                          "
                          icon="ChevronDownIcon"
                          size="20"
                          class="text-white"
                          style="margin-left: 8px"
                        />
                      </div>
                      <div v-if="isOpenDropdown" class="menu-select">
                        <div
                          @click="handleSelectPaymentType(item)"
                          class="cs-menu-item"
                          :class="{
                            'cs-item-active':
                              item.value === payment_status.value,
                          }"
                          v-for="item in paymentStatusOptions"
                          :key="item.value"
                        >
                          <span style="margin-right: 8px">{{
                            item.label
                          }}</span>
                          <feather-icon
                            v-if="item.value === payment_status.value"
                            icon="CheckIcon"
                            size="20"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <small
                    v-if="payment_status.value === 2"
                    class="text-right"
                    style="font-size: 13px"
                  >
                    <strong>{{ payInfo.time }}</strong>
                    bởi
                    <strong>{{ payInfo.name }}</strong>
                  </small>
                </div>
                <h5 class="fs-18 flex justify-between">
                  <span>Tổng tiền:</span>
                  <span>{{
                    appUtils.numberFormat(
                      (recordData.org_service_transaction &&
                        recordData.org_service_transaction.price) ||
                        0,
                      "VNĐ"
                    )
                  }}</span>
                </h5>
                <h5
                  class="fs-18 flex justify-between"
                  v-if="
                    recordData.payment_method === PAYMENT_METHOD.points &&
                    recordData.voucher_info
                  "
                >
                  <span>Số tiền sử dụng điểm:</span>
                  <span>{{
                    appUtils.numberFormat(
                      recordData.voucher_info.discount_amount || 0,
                      "VNĐ"
                    )
                  }}</span>
                </h5>
                <h4
                  v-if="
                    recordData.payment_method === PAYMENT_METHOD.points &&
                    recordData.voucher_info
                  "
                  class="font-weight-border fs-18 flex justify-between"
                  style="color: #20409b; margin-top: 8px; font-weight: bold"
                >
                  <span>Tổng thanh toán:</span>
                  <span>{{ getTotalPriceRemaining(recordData) }}</span>
                </h4>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
      id="hodo-modal-scrollable"
      size="xl"
      scrollable
      hide-header
      ok-only
      :ok-title="$t('lbl_close')"
      v-model="showModalExport"
    >
      <ModalExport
        :recordData="recordData"
        @mapLot="mapLot"
        @refresh="changeStatus()"
      />
    </b-modal>
  </b-overlay>
</template>

<script>
import { BRow, BCol, BFormCheckboxGroup, BFormCheckbox } from "bootstrap-vue";
import appUtils from "@/utils/appUtils";
import { ORDERS_STATUS, PAYMENT_METHOD } from "@/utils/constant";
import ProductItem from "./Components/ProductItem.vue";
import ReceiverInfo from "./Components/ReceiverInfo.vue";
import OrdersStatus from "./Components/OrdersStatus.vue";
import PaymentMethods from "./Components/PaymentMethods.vue";
import ModalExport from "./Components/ModalExport.vue";
import StepLine from "./Components/StepLine.vue";
import i18n from "@/libs/i18n";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ORDER_DELIVERY_STATES, PAYMENT_TYPE } from "@/utils/constant";
import EventBus from "@/utils/EventBus";

const paymentStatusOptions = [
  {
    label: i18n.t("obj_payment_status.not_payment"),
    value: 1,
  },
  {
    label: i18n.t("obj_payment_status.paid"),
    value: 2,
  },
  // {
  //   label: i18n.t("obj_payment_status.canceled"),
  //   value: 3
  // }
];
export default {
  name: "OrdersMarketPlaceDetail",
  components: {
    BRow,
    BCol,
    StepLine,
    ProductItem,
    ReceiverInfo,
    // OrdersStatus,
    PaymentMethods,
    // Definition
    ModalExport,
  },
  props: {
    // recordData: {
    //   type: Object,
    //   required: true
    // },
    orderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isOpenDropdown: false,
      payment_status: {},
      paymentStatusOptions,
      appUtils,
      ORDERS_STATUS,
      ordererForm: {},
      receiverForm: {},
      recordData: {
        order_items: [],
      },
      show: true,
      isEdit: false,
      showModalExport: false,
      PAYMENT_METHOD,
      PAYMENT_TYPE,
      order_statuses: [...ORDER_DELIVERY_STATES],
    };
  },
  computed: {
    historyCanceled() {
      return {
        reject_reason: this.recordData.reject_reason,
        ...this.recordData?.order_item_delivery_time?.find(
          (elm) => elm.to_state === 100
        ),
      };
    },
    payInfo() {
      if (this.recordData.payment_method === PAYMENT_METHOD.points) {
        const time = this.recordData?.org_service_transaction?.updated_at
          ? appUtils.formatDateTime(
              this.recordData?.org_service_transaction?.updated_at,
              "HH:mm DD/MM/YYYY"
            )
          : "";
        const name = this.recordData?.pay_by_infor?.name;

        return {
          time,
          name,
        };
      } else {
        const time = this.recordData?.payment_status_updated_at
          ? appUtils.formatDateTime(
              this.recordData?.payment_status_updated_at,
              "HH:mm DD/MM/YYYY"
            )
          : "";
        const name = this.recordData?.updated_by_infor?.name;

        return {
          time,
          name,
        };
      }
    },
  },
  watch: {
    orderId: {
      handler(data) {
        if (!data) {
          return;
        }
        this.order_statuses = [...ORDER_DELIVERY_STATES];
        this.viewDetailOrders();

        const foundPaymentStatus = this.paymentStatusOptions.find(
          (x) =>
            x.value === this.recordData.org_service_transaction?.payment_status
        );
        if (foundPaymentStatus) {
          this.payment_status = foundPaymentStatus;
        }
      },
      deep: true,
      immediate: true,
    },
    recordData: {
      handler(data) {
        this.recordData = data || {
          order_items: [],
        };
      },
      deep: true,
      immediate: true,
    },
    "recordData.org_service_transaction": {
      deep: true,
      handler(data) {
        const foundPaymentStatus = this.paymentStatusOptions.find(
          (x) => x.value === data.payment_status
        );
        if (foundPaymentStatus) {
          this.payment_status = foundPaymentStatus;
        }
      },
    },
  },
  created() {
    // this.viewDetailOrders();
  },
  methods: {
    handleCloseDropDown() {
      this.isOpenDropdown = false;
    },
    handleSelectPaymentType(option) {
      this.isOpenDropdown = false;

      let label;
      if (option.value === this.payment_status.value) return;

      if (option.value === PAYMENT_TYPE[0].value) {
        label = "Bạn có muốn đổi sang trạng thái chưa thanh toán không?";
      } else {
        label = "Bạn có muốn đổi sang trạng thái đã thanh toán không?";
      }

      this.$bvModal
        .msgBoxConfirm(label, {
          title: "Xác nhận trạng thái",
          size: "sm",
          okVariant: "primary",
          okTitle: "Xác nhận",
          cancelTitle: "Huỷ",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            // this.payment_status = option
            this.handleChangeStatus(option.value);
            return;
          } else {
            return;
          }
        });
    },
    async handleChangeStatus() {
      const params = {
        order_id: this.recordData.id,
        status: this.payment_status.value,
        tx_date: moment().valueOf(),
      };
      const res = await store
        .dispatch("ecomOrder/changePaymentStatusOrder", params)
        .then((response) => {
          this.changeStatus();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("Cập nhật trạng thái thanh toán thành công"),
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch((e) => {
          console.log(e);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("lbl_error_fetching_data"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return null;
        });
      return res;
    },
    handleToggleDropdown() {
      console.log(this.payment_status.value === PAYMENT_TYPE[0].value);
      if (this.recordData.status === 100) return;
      if (this.payment_status.value === PAYMENT_TYPE[0].value) {
        this.isOpenDropdown = !this.isOpenDropdown;
      }
    },
    mapLot(data) {
      this.recordData.order_items.forEach((x, index) => {
        const founded = data?.find(
          (i) => i.product_variant_id == x.product_variant_id
        );
        if (founded) {
          const convertLots = founded.data.map((x) => ({
            ...x,
            active: false,
          }));
          this.recordData.order_items[index].lot = convertLots;
        }
      });
    },
    openModalExport() {
      this.showModalExport = true;
    },
    changeStatus() {
      this.viewDetailOrders();
      EventBus.$emit("changeOrderStatus");
    },
    async viewDetailOrders() {
      const res = await store
        .dispatch("ecomOrder/fetchOrderById", { id: this.orderId })
        .then((response) => {
          this.show = false;
          this.recordData = { ...response.data } || {
            order_items: [],
          };
          if (this.recordData.order_item_delivery_time.length) {
            this.order_statuses.forEach((x, index) => {
              const foundStep = this.recordData.order_item_delivery_time?.find(
                (i) => i.to_state === x.order_number
              );
              if (foundStep) {
                if (x.date) {
                  if (foundStep.time_changed > x.date) {
                    this.order_statuses[index] = {
                      ...this.order_statuses[index],
                      updated_name: foundStep?.user_infor?.name,
                      date: foundStep.time_changed,
                    };
                  }
                } else {
                  this.order_statuses[index] = {
                    ...this.order_statuses[index],
                    updated_name: foundStep?.user_infor?.name,
                    date: foundStep.time_changed,
                  };
                }
              }
            });
          }
          this.showModalExport = false;
        })
        .catch((e) => {
          console.log(e);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("lbl_error_fetching_data"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return null;
        });
      return res;
    },
    onSubmit(event) {
      event.preventDefault();
    },
    onReset(event) {
      event.preventDefault();
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    handleGetDataReceiver(type) {
      return (
        this.recordData?.contact_order?.find((item) => item?.type === type) ||
        {}
      );
    },
    getTotalPriceRemaining(item) {
      const price =
        item.org_service_transaction?.price -
        item.voucher_info?.discount_amount;

      return appUtils.numberFormat(price < 0 ? 0 : price, "VNĐ");
    },
  },
};
</script>

<style scoped lang="scss">
.not-payment ::v-deep {
  background-color: rgb(243, 129, 8) !important;
  color: white !important;
}

.reject ::v-deep {
  color: white !important;
  background-color: red !important;
}

.payment ::v-deep {
  color: white !important;
  background-color: #17ad73 !important;
}

.status {
  padding: 8px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-radius: 4px;
  font-size: 16px;
  user-select: none;
  width: 100%;
}

.select-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.menu-select {
  background-color: #fff;
  position: absolute;
  top: 120px;
  right: 0;
  z-index: 2;
  // width: 100%;
  margin: 50px 14px 0 0;
  border-radius: 6px;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.cs-menu-item {
  cursor: pointer;
  width: 250px;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  justify-content: space-between;

  &:hover {
    background-color: rgba(21, 76, 205, 0.1);
  }

  span {
    display: block;
    // width: 100%;
    // height: 100%;
  }
}

.cs-item-active {
  background-color: #20419b !important;
  color: white;
}
</style>
